import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getException } from "lib/helpers/errorHelper";
import { reportsService } from "services/ReportsService";
import { DatasheetReport, EmployeeReport, ChildrenReport, RelativeReport } from "types";

const name = "actions.reports";

interface Reports {
  employees: EmployeeReport[];
  children: ChildrenReport[];
  relatives: RelativeReport[];
  error: string | any;
  loading: boolean;
}

const initialState: Reports = {
  employees: [],
  children: [],
  relatives: [],
  loading: false,
  error: "",
};

export const getEmployees = createAsyncThunk(
  `${name}/GetEmployees`,
  async (payload: DatasheetReport, { rejectWithValue }) => {
    try {
      const response = await reportsService.getEmployees(payload);
      return response;
    } catch ({ data }) {
      return rejectWithValue(getException(data));
    }
  }
);

export const getChildren = createAsyncThunk(
  `${name}/GetChildren`,
  async (payload: DatasheetReport, { rejectWithValue }) => {
    try {
      const response = await reportsService.getChidren(payload);
      return response;
    } catch ({ data }) {
      return rejectWithValue(getException(data));
    }
  }
);

export const getRelatives = createAsyncThunk(
  `${name}/GetRelatives`,
  async (payload: DatasheetReport, { rejectWithValue }) => {
    try {
      const response = await reportsService.getRelatives(payload);
      return response;
    } catch ({ data }) {
      return rejectWithValue(getException(data));
    }
  }
);

const reportsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    /***************** Employees ************************************/
    builder.addCase(getEmployees.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getEmployees.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.employees = payload;
      state.error = null;
    });

    builder.addCase(getEmployees.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
    /***************** children ************************************/
    builder.addCase(getChildren.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getChildren.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.children = payload;
      state.error = null;
    });

    builder.addCase(getChildren.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
    /***************** Relatives ************************************/
    builder.addCase(getRelatives.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getRelatives.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.relatives = payload;
      state.error = null;
    });

    builder.addCase(getRelatives.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
  reducers: {
    resetLoading: (state) => {
      state.loading = false;
    },
  },
});

export const { resetLoading } = reportsSlice.actions;

export default reportsSlice.reducer;
